import type { BragItem as BragItemType } from './types';
import style from './BragBar.module.scss';
import RichText from '../RichText';
import Image from 'next/image';
interface BragItemProps {
  item: BragItemType;
  index: number;
}
export default function BragItem({
  item,
  index
}: BragItemProps) {
  if (item.type === 'image' && item.logo) {
    return item.link ? <a target="_blank" rel="noopener noreferrer" href={item.link} key={`brag-item-${index}`}>
				<Image className={style.image} src={item.logo} alt="" role="presentation" data-testid="brag-item" width={150} height={65} />
			</a> : <Image key={`brag-item-${index}`} className={style.image} src={item.logo} alt="" role="presentation" data-testid="brag-item" width={150} height={65} />;
  }
  if (item.type === 'text' && item.richText) {
    return <RichText text={item.richText} key={`brag-item-${index}`} data-testid="brag-item" />;
  }
  return null;
}